import { usePrevious } from '@patrianna/shared-hooks'
import { useEffect, useState } from 'react'

import { useAppDispatch } from 'src/store/hooks'
import { optOutArbitration } from 'src/store/modules/user/actions'

export const useOptOutArbitrationRequest = () => {
  const dispatch = useAppDispatch()
  const [isSent, setIsSent] = useState(false)
  const [loading, setLoading] = useState(false)
  const [rejected, setRejected] = useState(false)
  const prevLoading = usePrevious(loading)

  const send = () => {
    dispatch(optOutArbitration({ setLoading, setRejected }))
  }

  useEffect(() => {
    if (!loading && prevLoading === true) {
      setIsSent(true)
    }
  }, [loading, prevLoading])

  return {
    rejected,
    loading,
    isSent,
    send,
  }
}
